import React from "react";
import CheckboxColumn from "./CheckboxColumn";
import { Link } from "react-router-dom";

export default (customFieldId) => [
    {
        Header: "",
        disableSortBy: true,
        disableFilters: true,
        accessor: "id",
        width: 10,
        collapse: true,
        Cell: (p) => <CheckboxColumn {...p} assignTo="WORKER" customFieldId={customFieldId} />
    },
    {
        Header: "First Name",
        accessor: "firstName",
        isNotClickable: true,
        Cell: ({ row: { original }, value }) => {
            return <Link to={`/workers/${original.id}`}>{value || "-"}</Link>;
        },
    },
    {
        Header: "Last Name",
        accessor: "lastName",
    },
    {
        Header: "Email",
        accessor: "email",
    },
];
